import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';

let component = {
    const: {}
};

export default {
    components: {},
    props: {},
    data() {
        return {
            formData: this.getInitFormData()
        };
    },
    methods: {
        getInitFormData() {
            return cloneDeep({
                ProtoTypeNum: 0,
                ProtoTypeDeductibleNum: 0,
                OrderNums: 0,
                BindNums: 0,
                UpgradeDeviceNums: 0,
                BookProtoTypeNum:0,
                BookProtoTypeDeductibleNum:0,
                HiCProtoTypeNum:0,
                HiCProtoTypeDeductibleNum:0
            });
        },
        setValue(Data) {
            this.formData = cloneDeep(util.filterAndSetData(this.getInitFormData(), Data));
        },
        validate() {

            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "样机数量",
                    value: this.formData.ProtoTypeNum,
                    required: true,
                    more0: true,
                }, {
                    name: "已抵扣数量",
                    value: this.formData.ProtoTypeDeductibleNum,
                    required: true,
                    more0: true,
                }]
            });
            if (!flag) {
                return;
            }
            return this.formData;
        },
        resetFields() {
            this.formData = this.getInitFormData();
        }
    },
    computed: {},
    mounted() {}
};


// WEBPACK FOOTER //
// ./src/common/components/agent-other-info1/vm.js